<template>
	<el-table
		:data="orderedEvents"
		:show-header="false"
		max-height="300px">
		<el-table-column label="Date" width="130">
			<template slot-scope="scope">
				<strong class="date">{{ formatDate(scope.row.time) }}</strong> &middot; {{ formatTime(scope.row.time) }}
			</template>
		</el-table-column>

		<el-table-column label="Type" width="100">
			<template slot-scope="scope">
				<strong class="activity-type">{{ formatType(scope.row.type) }}</strong>
			</template>
		</el-table-column>

		<!-- Value -->
		<el-table-column label="Value" width="180">
			<template slot-scope="scope">
				<div v-if="scope.row.steps">
					<strong>{{ scope.row.steps }}</strong> steps
				</div>
				<div v-if="scope.row.minutes">
					<strong>{{ scope.row.minutes }}</strong> minutes
				</div>
			</template>
		</el-table-column>

		<!-- Details -->
		<el-table-column label="Detail">
			<template slot-scope="scope">
				&nbsp;
			</template>
		</el-table-column>
	</el-table>
</template>

<script>
import ActivityAnalysis from '.'

export default {
	name: 'patient-exercise-card-analysis-table',
	extends: ActivityAnalysis,

	methods: {
		formatType(type) {
			return type.split(':')[1]
		}
	},

	computed: {
		orderedEvents() {
			return this.event.slice().sort((a, b) => (a.time - b.time))
		}
	}
}
</script>
<style lang="scss" scoped>
.activity-type {
	text-transform: capitalize;
}
</style>
